import React from 'react';
const ButLogout = React.lazy(() => import('../components/Auth/ButLogout'));
const Dashboard = React.lazy(() => import('../views/Dashboard/Dashboard'));
const PanelSvom = React.lazy(() => import('../views/PanelSvom'));
const Light = React.lazy(() => import('../components/WeatherLight/HomeWeather'));
const PanelCalibration = React.lazy(() => import('../views/PanelCalibration'));
const PanelPerformance = React.lazy(() => import('../views/PanelPerformance'));
const PanelShifts = React.lazy(() => import('../views/PanelShifts'));
const PanelMonitor = React.lazy(() => import('../views/PanelMonitor'));
const PanelAdministration = React.lazy(() => import('../views/Admin/PanelAdministration'));
const Construction = React.lazy(() => import('../components/Services/Construction'));

const Routes = [
  { path: '/gic-web/logout', name: 'ButLogout', component: ButLogout },
  { path: '/gic-web/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/gic-web/dashone', name: 'Dashboard', exact: true, component: Light },
  { path: '/gic-web/statussvom', name: 'Panel Svom', component: PanelSvom },
  { path: '/gic-web/calibration', name: 'Calibration', component: PanelCalibration },
  { path: '/gic-web/performance', name: 'Performance', component: PanelPerformance },
  { path: '/gic-web/shifts', name: 'Panel Shifts', component: PanelShifts },
  { path: '/gic-web/monitoring', name: 'Panel Monitoring', component: PanelMonitor },
  { path: '/gic-web/Administrateur', name: 'Administration', component: PanelAdministration },
  { path: '/gic-web/construction', name: 'Construction', component :Construction }
];

// @ts-ignore
export default Routes;

